import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export default {
  gsmKey: plaintextValidator(config),
  clientId: plaintextValidator(config),
  clientSecret: plaintextValidator(config),
  username: plaintextValidator(config),
  password: plaintextValidator(config)
};
